import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5e5a1ad0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "content"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "应急会商", -1));
const _hoisted_3 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_svg_icon = _resolveComponent("svg-icon");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_switch = _resolveComponent("el-switch");
  const _component_BatterTableDataView = _resolveComponent("BatterTableDataView");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
    class: "crumbs"
  }, {
    default: _withCtx(() => [_createVNode(_component_svg_icon, {
      "icon-class": "house"
    }), _hoisted_2]),
    _: 1
  }), _createVNode(_component_BatterTableDataView, {
    "table-id": 24,
    onOnFetchData: $options.onFetchData
  }, {
    enable: _withCtx(data => [_createVNode(_component_el_switch, {
      "active-color": "#0078D7",
      disabled: data.rowId <= 1,
      "model-value": $data.enableMap[data.rowId],
      onChange: v => $options.enableChange(data.rowId, v)
    }, null, 8, ["disabled", "model-value", "onChange"])]),
    communities: _withCtx(data => [_createElementVNode("span", null, _toDisplayString(data.rowId > 1 ? data.rowData.map(p => p.communityName).join('/') : '-'), 1)]),
    userIds: _withCtx(data => [_createElementVNode("span", null, _toDisplayString(data.rowId > 1 ? data.rowData.length : '-'), 1)]),
    image: _withCtx(data => [_createElementVNode("img", {
      src: data.rowData,
      style: {
        "width": "60px",
        "height": "60px",
        "object-fit": "cover"
      }
    }, null, 8, _hoisted_3)]),
    _: 1
  }, 8, ["onOnFetchData"])]);
}